<mat-form-field appearance="fill" class="full-width slim-field" [floatLabel]="'always'">
    <mat-label>{{ label }}</mat-label>
    <input #input type="text" matInput [formControl]="amount" maxlength="256" />
</mat-form-field>
